import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router-dom";

import Box from "@mui/material/Box";

import LeftSideMenu from "./LeftSideMenu";
import { startMasterDataFetching } from "../../redux/reducers/drmLiveLoadMasterDataSlice";

import clsx from "clsx";
import "./LeftMenuLayout.sass";


function LeftMenuLayout({ children }) {
  const { isOpenMenu } = useSelector((state) => state?.leftMenu || {});
  const dispatch = useDispatch();

  useEffect(() => {

    dispatch(startMasterDataFetching({ masterDataType: 'all' }));
  }, []);

  return (
    <Box display="flex" sx={{ width: "100vw" }}>
      <Box className={clsx("element", isOpenMenu && "menu-open")}>
        <LeftSideMenu />
      </Box>

      <Box
        component="main"
        className={clsx("children-class", isOpenMenu && "menu-open")}
      >
        {children}
        <Outlet />
      </Box>
    </Box>
  );
}

export default LeftMenuLayout;